// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/html-default.scss
// module id = 2570
// module chunks = 0